<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-form v-model="isValid" ref="form">
          <v-card>
            <v-toolbar color="white" fixed>
              <h3>{{ $i18n.t(label) }}</h3>
            </v-toolbar>
            <v-card-text>
              <v-container class="py-0">
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="5">
                        <z-name-master-select
                          :hideAddNew="true"
                          v-model="trip.bodyType"
                          :label="'Body Type'"
                          :type="10"
                        />
                      </v-col>
                      <v-col cols="12" md="5">
                        <z-vehicle-type-select
                          categories="true"
                          v-model="trip.truckType"
                          :bodyType="trip.bodyType"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="2">
                        <v-select
                          v-model="trip.viewType"
                          :label="$i18n.t('View Type')"
                          @click.native.stop
                          type="number"
                          item-text="name"
                          item-value="value"
                          :items="[
                            { name: 'My Suppliers', value: 1 },
                            { name: 'Any One', value: 2 },
                          ]"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="4" md="3" lg="2">
                        <z-name-master-auto-fill
                          :label="$i18n.t('Material')"
                          v-model="trip.material"
                          :disabled="!!trip._id"
                          :type="6"
                          :addNewLabel="'Add Material'"
                          @click.native.stop
                        />
                      </v-col>

                      <v-col cols="12" sm="4" md="2" lg="2">
                        <v-text-field
                          v-model="trip.units"
                          @click.native.stop
                          type="number"
                          :label="$i18n.t('Quantity') + '/' + $i18n.t('Units')"
                        />
                      </v-col>

                      <v-col cols="12" sm="4" md="3" lg="4">
                        <v-row>
                          <v-col cols="12" sm="4" md="3" lg="7">
                            <v-text-field
                              v-model="trip.weight"
                              :disabled="!!trip._id"
                              @click.native.stop
                              type="number"
                              :label="$i18n.t('Weight')"
                            />
                          </v-col>

                          <v-col cols="12" sm="4" md="3" lg="5">
                            <v-select
                              v-model="trip.weightUnit"
                              :label="$i18n.t('Unit')"
                              :disabled="!!trip._id"
                              @click.native.stop
                              type="number"
                              item-text="name"
                              item-value="value"
                              :items="[
                                { name: 'KG', value: 0 },
                                { name: 'Tonnes', value: 1 },
                                { name: 'PCS', value: 2 }
                              ]"
                            />
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12" sm="4" md="4" lg="4">
                        <v-row>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            <v-text-field
                              :label="$i18n.t('Length')"
                              v-model="trip.length"
                              :disabled="!!trip._id"
                              @click.native.stop
                              type="number"
                            />
                          </v-col>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            <v-select
                              v-model="trip.measureUnit"
                              :label="$i18n.t('Unit')"
                              :disabled="!!trip._id"
                              @click.native.stop
                              type="number"
                              item-text="name"
                              item-value="value"
                              :items="[
                                { name: 'CMS', value: 0 },
                                { name: 'Inches', value: 1 },
                                { name: 'Feet', value: 2 },
                                { name: 'Meter', value: 3 },
                              ]"
                            />
                          </v-col>
                          <v-col cols="12" sm="4" md="4" lg="4">
                            <v-text-field
                              :label="$i18n.t('Distance')"
                              v-model="trip.dist"
                              :disabled="!!trip._id"
                              @click.native.stop
                              type="number"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12" md="2">
                        <z-date-picker
                          :label="$i18n.t('Pickup Date')"
                          v-model="trip.startTime"
                          timestamp
                        />
                      </v-col>
                      <v-col cols="12" md="2" v-if="false">
                        <z-time-picker
                          :label="$i18n.t('Pickup Time')"
                          v-model="trip.startTime"
                          timestamp="trip.startTime"
                        />
                      </v-col>
                      <v-col cols="12" md="3" v-if="false">
                        <z-address-autofill
                          :label="$i18n.t('PickUp Adress')"
                          v-model="trip.src"
                        />
                      </v-col>
                      <v-col cols="12" md="2" v-if="false">
                        <z-country-select
                          :label="$i18n.t('PickUp Country')"
                          v-model="trip.src.country"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <z-city-select
                          :label="$i18n.t('PickUp City')"
                          v-model="trip.src.city"
                          :country="trip.src.country"
                        />
                      </v-col>
                      <v-col cols="12" md="3" v-if="false">
                        <z-address-autofill
                          :label="$i18n.t('Delivery Adress')"
                          v-model="trip.dst"
                        />
                      </v-col>
                      <v-col cols="12" md="2" v-if="false">
                        <z-country-select
                          :label="$i18n.t('Delivery Country')"
                          v-model="trip.dst.country"
                        />
                      </v-col>
                      <v-col cols="12" md="2">
                        <z-city-select
                          :label="$i18n.t('Delivery City')"
                          v-model="trip.dst.city"
                          :country="trip.dst.country"
                        />
                      </v-col>
                      <v-col cols="12" sm="4" md="2" lg="4">
                        <v-text-field
                          :label="$i18n.t('Wish Price')"
                          v-model="trip.wishPrice"
                          @click.native.stop
                          type="number"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <small>*indicates required field</small>
              <v-spacer></v-spacer>
              <!-- <v-btn
                text
                fab
                small
                color="teal lighten-2"
                :title="$i18n.t('Audit Logs')"
                @click="showAuditLog = true"
                v-if="entity.showAuditLog"
              >
                <v-icon>mdi-database</v-icon>
              </v-btn> -->
              <v-btn
                color="success darken-1"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
                >{{ $i18n.t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <!-- <z-audit-log
      v-if="entity"
      :showDialog="showAuditLog"
      :entity_id="entity._id"
      entity="Entity"
      @closeAuditLog="showAuditLog = false"
    >
    </z-audit-log> -->
  </v-container>
</template>

<script>
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "LoadAdd",
  props: {
    label: {
      default: "Add Load",
    },
    entity_id: {
      default: null,
    },
    singlePage: {
      default: true,
    },
    value: {
      default: null,
    },
  },
})
export default class LoadAdd extends Vue {
  isValid = true;
  isClone = null;
  isEdit = false;
  showAuditLog = false;
  tripPOSO = {
    startTime: null,
    viewType: 1,
    src: { country: "India", state: null, city: null, addressLine: null },
    dst: { country: "India", state: null, city: null, addressLine: null },
  };

  trip = this.tripPOSO;

  select(data) {
    this.$emit("select", data);
  }

  closeDialog() {
    this.$emit("closeDialog", false);
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    fullName: [(v) => !!v || this.$i18n.t("Full Name is required")],
    addressCountry: [(v) => !!v || this.$i18n.t("Country is required")],
    addressCity: [(v) => !!v || this.$i18n.t("City is required")],
    addressState: [(v) => !!v || this.$i18n.t("State is required")],
    addressAddressLine: [(v) => !!v || this.$i18n.t("Address is required")],
    adminName: [(v) => !!v || this.$i18n.t("Admin Name is required")],
    countryCodeAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone Code is required"),
    ],
    phoneAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone no is required"),
      (v) =>
        !isNaN(parseInt(v)) || this.$i18n.t("Admin Phone no should be valid"),
    ],
    email: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  };

  addItem(_list) {
    if (!_list) {
      _list = [];
    }
    _list.push({});
    return _list;
  }

  id = null;

  get loading() {
    return common.loading;
  }

  remove(_index) {
    this.entity.contactPeople.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/load/save", this.trip);
      common.showMessage(`Load Saved Successfully`);
      common.setLoading(false);

      if (this.singlePage) {
        this.$emit("select", {
          name: response.name,
          _id: response._id,
        });
        this.trip = this.tripPOSO;
        this.$emit("reload");
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  prepareResponse(response) {
    // console.log("d");
  }

  async get(id) {
    try {
      const entity = await doGet("/api/load/" + id + "/detail");
      this.prepareResponse(entity);
      this.entity = entity;
      this.id = this.entity._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.singlePage) {
      if (this.entity_id) {
        await this.get(this.entity_id);
      }
    } else if (this.value) {
      this.prepareResponse(this.value);
      this.entity = this.value;
      this.id = this.entity._id;
    } else if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    } else if (this.$route.params.clone_id) {
      this.isClone = true;
      await this.get(this.$route.params.clone_id);
      this.entity._id = null;
      this.entity.version = null;
    }
  }
}
</script>

<style scoped>
.left-headers {
  text-transform: none;
  top: -15px;
  left: 10px;
  font-size: 12px;
}
.right-headers {
  text-transform: none;
  top: -10px;
  left: 10px;
  font-size: 12px;
}
</style>
